<template>
  <v-container fluid fill-height justify-center id="scrolling-techniques-7" class="overflow-y-auto" key="login">
    <v-row class="max-w">
      <v-col cols="12">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          class="px-5"
        >
          <div class="display-1 font-weight-medium mb-6">
            {{ $t('zaloguj') }}
          </div>

          <v-text-field
          v-model="email"
          :rules="emailRules"
          label="E-mail"
          required
          ></v-text-field>
          
          <v-text-field
          v-model="password"
          :rules="passwordRules"
          :label="$t('haslo')"
          required
          type="password"></v-text-field>
            
          <div class="text-center mt-8 t-primary">
            <v-btn 
              :loading="saving"
              :disabled="saving" 
              @click="postForm"
              x-large class="w-100" color="primary">{{ $t('zaloguj') }}</v-btn>
          </div>
          <div class="text-center mt-2">
            <v-btn x-large text class="w-100" to="/remind">{{ $t('przyp-haslo') }}</v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
  export default {
    data: () => ({
      valid: true,
      email: '',
      emailRules: [
        v => !!v || 'Wypełnij E-mail',
        v => /.+@.+/.test(v) || 'E-mail jest nieprawidłowy'
      ],
      password: '',
      passwordRules: [
        v => !!v || 'Wypełnij hasło'
      ],
      checkbox: false,
      saving: false
    }),
    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      postForm () {
        this.saving = true;

        const formData = new URLSearchParams();
        formData.append('email', this.email);
        formData.append('password', this.password);

        this.$store.dispatch('login', formData)
        .then(res => {
          this.saving = false;
          if (res.error) {
            this.$store.commit("alert", {
              color: "error",
              text: res.error.code
            });
          } else {
            console.log(3);
            this.$router.push({ path: '/controllers' });
          }
        });
      }
    }
  }
</script>

<style>
  .btn-back {
    margin-left: -8px;
  }
</style>

